import React from 'react';
import PropTypes from 'prop-types'
import { View, Text } from 'react-native';
import Constants from 'expo-constants';
import { ScreenContainer } from '../../../components';

import { useQuery, gql } from '@apollo/client';

const GET_STATUS = gql`
  query GetStatus {
    status {
      status
      timestamp
    }
  }
`;

const DisplayStatus = () => {
  const { loading, error, data } = useQuery(GET_STATUS);

  if (loading) return <Text>Loading...</Text>;
  if (error) return <Text>Error :(</Text>;

  const { status, timestamp } = data.status;

  return (
    <View>
      <Text>{`Status: ${status}`}</Text>
      <Text>{`Timestamp: ${timestamp}`}</Text>
      <Text>{`Test var: ${Constants?.expoConfig?.extra?.testVar} - ${process.env.EXPO_PUBLIC_TEST_VAR}`}</Text>
      <Text>Change test</Text>
    </View>
  );
};

const GuestWelcomeScreen = ({ navigation }) => {

  return (
    <ScreenContainer>
      <DisplayStatus />
      <Text>TEST Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</Text>  
    </ScreenContainer>
  )
}

GuestWelcomeScreen.propTypes = {
  navigation: PropTypes.object.isRequired,
}

export default GuestWelcomeScreen;